import api from "./api";

// Update the Part interface
export interface Part {
    _id?: string;
    partNumber: string;
    description: string;
    hsCode: string;
    countryOfOrigin?: string;
    unitValue?: number;
    notes?: string;
    active?: boolean;
    usmca?: string;
    usmcaOriginCriteria?: string;
    usmcaQualificationMethod?: string;
    vendorManufacturer?: string;
}


export const partService = {
    getAllParts: async (): Promise<Part[]> => {
        const response = await api.get("/parts");
        return response.data;
    },

    getPartById: async (id: string): Promise<Part> => {
        const response = await api.get(`/parts/${id}`);
        return response.data;
    },

    createPart: async (part: Part): Promise<Part> => {
        const response = await api.post("/parts", part);
        return response.data;
    },

    updatePart: async (id: string, part: Part): Promise<Part> => {
        const response = await api.put(`/parts/${id}`, part);
        return response.data;
    },

    deletePart: async (id: string): Promise<void> => {
        await api.delete(`/parts/${id}`);
    },

    downloadTemplate: async (): Promise<void> => {
        const response = await api.get("/parts/template/download", {
            responseType: "blob",
        });

        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'parts_template.csv');

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        if (link.parentNode) {
            link.parentNode.removeChild(link);
        }
        window.URL.revokeObjectURL(url);
    },

    upload: async (file: File): Promise<any> => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await api.post("/parts/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    },

    uploadParts: async (file: File): Promise<any> => {
        return partService.upload(file);
    },

    downloadAll: async (): Promise<void> => {
        const response = await api.get("/parts/download/all", {
            responseType: "blob",
        });

        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set filename with timestamp
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        link.setAttribute('download', `parts_export_${timestamp}.csv`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        if (link.parentNode) {
            link.parentNode.removeChild(link);
        }
        window.URL.revokeObjectURL(url);
    },

    // Renamed from downloadAllParts to downloadAll for consistency
    downloadAllParts: async (): Promise<void> => {
        return partService.downloadAll();
    },
};
